import {AbstractPart, TextPart, SpritePart} from '@gongxigames/framework/core/fragments/display/advancedText/AdevancedTextData';

const regLines = /(\r\n|\r|\n)/u;
const regText = /^([^<]+)(<img|<text|$)/u;
const regImgTag = /^<img sprite='([^']+)'[^/]*\/>/u;
const regTextTag = /^<text style='([^']+)'[^>]*>([^<]+)<\/text>/u;

export const AdvancedTextParser = function(text: string): AbstractPart[][] {
    const lines = [];
    const textLines: string[] = text.split(regLines).filter( line => !(/\n/u.test(line)));

    for (const text of textLines) {
        let textLine = text;
        let linePart: TextPart | SpritePart;
        const line = [];

        while (textLine.length) {

            let match = textLine.match(regText);

            if (match) {
                linePart = {
                    type: 'text',
                    text: match[1]
                };

                line.push(linePart);

                textLine = textLine.substr(match.index! + match[1].length);
            }

            match = textLine.match(regImgTag);

            if (match) {
                linePart = {
                    type: 'sprite',
                    sprite: match[1]
                };

                line.push(linePart);

                textLine = textLine.substr(match[0].length);
            }

            match = textLine.match(regTextTag);

            if (match) {
                linePart = {
                    type: 'text',
                    style: match[1],
                    text: match[2]
                };

                line.push(linePart);

                textLine = textLine.substr(match[0].length);
            }
        }

        lines.push(line);
    }

    return lines;
};
